import React, {useRef} from "react";

const SingleInfoSection = ({label, info, showCopyBtn, copyBtnText, showChangeBtn, onChange}) => {
    const clipboardRef = useRef(null);
    if (info === null || info === undefined) return <></>

    const copyToClipBoard = () => {
        clipboardRef.current.textContent = "Copied";
        navigator.clipboard.writeText(info);
        setTimeout(() => {
            clipboardRef.current.textContent = copyBtnText;
        }, 2000)
    }

    return (
        <div className="single-info justify-content-between">
            <div className="info-header">{label}</div>
            <div className="info-text">{info}</div>
            <div className="info-btn text-end">
                {showCopyBtn && 
                    <div className="copy-text-btn" ref={clipboardRef} onClick={copyToClipBoard}>{copyBtnText}</div>
                }
                {showChangeBtn && 
                    <div className="copy-text-btn" data-bs-toggle="modal" data-bs-target="#profileUpdateModal" onClick={onChange}>Change</div>
                }
            </div>
        </div>
    )
}

export default SingleInfoSection;
